<template>
  <ImportSourceCard
    :import-source="importSource"
    :is-expanded="isExpanded"
    @import-source-removed="emit('importSourceRemoved')"
    @toggle-expanded="emit('toggleExpanded', $event)"
  />
</template>
<script setup lang="ts">
import { ImportSource } from "@core/domain/models/import-source.model";
import ImportSourceCard from "../../Components/ImportSourceCard.vue";

const emit = defineEmits<{
  (e: "importSourceRemoved"): void;
  (e: "toggleExpanded", event: MouseEvent): void;
}>();

defineProps<{
  importSource: ImportSource;
  readonly?: boolean;
  isExpanded?: boolean;
}>();
</script>
